(function () {
  const root = document.getElementById("orbita-quiz");
  if (!root) return;

  const VARIANT_ID = Number(root.dataset.variantId);
  const PRICE = root.dataset.price;
  const ANTES = root.dataset.compare;
  const PRODUCT_TITLE = root.dataset.productTitle || "tu plan";

  const allSteps = Array.from(root.querySelectorAll(".oq-step"));
  const order = allSteps.map(s => s.dataset.step);
  let current = 0;
  const state = {}; // field name -> value (string or array)
  const labels = {}; // field name -> { value: displayLabel } for the resumen

  const ringFill = document.getElementById("oq-ring-fill");
  const RING_LEN = 276.4602;
  const stepNumEl = document.getElementById("oq-step-num");
  const stepTotalEl = document.getElementById("oq-step-total");
  const nextBtn = document.getElementById("oq-next");
  const backBtn = document.getElementById("oq-back");
  const footer = root.querySelector(".oq-footer");

  function stepEl(stepId) { return allSteps.find(s => s.dataset.step === stepId); }

  // --- generic field binding -------------------------------------------
  // Single-select: .oq-cards[data-name] / .oq-pills[data-name], buttons with data-value
  root.querySelectorAll(".oq-cards[data-name], .oq-pills[data-name]").forEach(group => {
    const name = group.dataset.name;
    group.querySelectorAll("button").forEach(btn => {
      btn.addEventListener("click", () => {
        group.querySelectorAll("button").forEach(b => b.classList.remove("selected"));
        btn.classList.add("selected");
        state[name] = btn.dataset.value;
        const strong = btn.querySelector("strong");
        labels[name] = strong ? strong.textContent : btn.textContent.trim();
        onFieldChange(group);
      });
    });
  });

  // Multi-select checkboxes: .oq-check-grid[data-name]
  root.querySelectorAll(".oq-check-grid[data-name]").forEach(group => {
    const name = group.dataset.name;
    const inputs = group.querySelectorAll("input[type=checkbox]");
    inputs.forEach(cb => {
      cb.addEventListener("change", () => {
        if (cb.value === "ninguna" && cb.checked) {
          inputs.forEach(other => { if (other !== cb) other.checked = false; });
        } else if (cb.checked) {
          const ninguna = Array.from(inputs).find(i => i.value === "ninguna");
          if (ninguna) ninguna.checked = false;
        }
        const checked = Array.from(inputs).filter(i => i.checked);
        state[name] = checked.map(i => i.value);
        labels[name] = checked.map(i => (i.closest("label").textContent || "").trim()).join(", ");
        onFieldChange(group);
      });
    });
  });

  // Text / textarea / native select inputs with a name attribute
  root.querySelectorAll(".oq-step [name]").forEach(el => {
    if (el.closest(".oq-check-grid")) return; // handled above
    const name = el.name;
    const sync = () => {
      state[name] = el.value;
      if (el.tagName === "SELECT") labels[name] = el.options[el.selectedIndex]?.text || el.value;
      else labels[name] = el.value;
      onFieldChange(el);
    };
    el.addEventListener("input", sync);
    el.addEventListener("change", sync);
  });

  // Any element with data-reveal-when="fieldName:value1,value2" is shown only
  // when that field's current state matches one of the listed values —
  // decoupled from the field itself, so several targets can react to the
  // same source field independently (e.g. two textareas revealed by
  // different checkboxes within the same checklist).
  function updateReveals() {
    root.querySelectorAll("[data-reveal-when]").forEach(target => {
      const sep = target.dataset.revealWhen.indexOf(":");
      const name = target.dataset.revealWhen.slice(0, sep);
      const wanted = target.dataset.revealWhen.slice(sep + 1).split(",").map(s => s.trim());
      const val = state[name];
      const matches = Array.isArray(val) ? val.some(v => wanted.includes(v)) : wanted.includes(val);
      target.hidden = !matches;
    });
  }

  function onFieldChange() {
    updateReveals();
    validateCurrentStep();
  }

  // --- step validation ---------------------------------------------------
  function validateCurrentStep() {
    const el = allSteps[current];
    let ok = true;

    el.querySelectorAll("input[required], select[required], textarea[required]").forEach(f => {
      if (!f.value) ok = false;
    });
    el.querySelectorAll(".oq-cards[data-required], .oq-pills[data-required]").forEach(g => {
      if (!state[g.dataset.name]) ok = false;
    });
    el.querySelectorAll(".oq-check-grid[data-required]").forEach(g => {
      if (!state[g.dataset.name] || state[g.dataset.name].length === 0) ok = false;
    });

    nextBtn.disabled = !ok;
    return ok;
  }

  // --- navigation ----------------------------------------------------------
  function showStep(idx) {
    const stepId = order[idx];
    allSteps.forEach(s => s.classList.toggle("active", s.dataset.step === stepId));
    stepNumEl.textContent = idx + 1;
    stepTotalEl.textContent = order.length;
    const progress = (idx + 1) / order.length;
    ringFill.style.strokeDashoffset = String(RING_LEN * (1 - progress));
    backBtn.style.visibility = idx === 0 ? "hidden" : "visible";
    footer.style.display = stepId === "resumen" ? "none" : "flex";
    if (stepId === "resumen") renderResumen();
    validateCurrentStep();
  }

  nextBtn.addEventListener("click", () => {
    if (!validateCurrentStep()) return;
    if (current < order.length - 1) { current += 1; showStep(current); }
  });
  backBtn.addEventListener("click", () => {
    if (current > 0) { current -= 1; showStep(current); }
  });

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, s => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[s]));
  }

  // --- resumen + comprar -----------------------------------------------
  function renderResumen() {
    const summaryEl = document.getElementById("oq-summary");
    if (summaryEl) {
      let rows = "";
      allSteps.forEach(s => {
        s.querySelectorAll("[data-name]").forEach(g => {
          const name = g.dataset.name;
          const label = g.dataset.label;
          if (!label || labels[name] === undefined || labels[name] === "") return;
          rows += `<div>${escapeHtml(label)}: <b>${escapeHtml(labels[name])}</b></div>`;
        });
      });
      summaryEl.innerHTML = rows;
    }
    const buyBtn = document.getElementById("oq-buy-btn");
    // Con rebaja se muestran los dos precios; sin ella, solo el actual.
    // innerHTML y no textContent porque el anterior va tachado.
    if (buyBtn) {
      const hayRebaja = ANTES && parseFloat(ANTES.replace(",", ".")) > parseFloat(PRICE.replace(",", "."));
      buyBtn.innerHTML = hayRebaja
        ? `Comprar — <s style="opacity:.6;font-weight:500">${ANTES} €</s> ${PRICE} €`
        : `Comprar — ${PRICE} €`;
    }
  }

  document.getElementById("oq-buy-btn").addEventListener("click", (e) => {
    const btn = e.currentTarget;
    if (btn.disabled) return;
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = "Redirigiendo al pago...";

    const properties = {};
    allSteps.forEach(s => {
      s.querySelectorAll("[data-name]").forEach(g => {
        const name = g.dataset.name;
        const label = g.dataset.label;
        if (!label) return;
        const val = state[name];
        properties[label] = Array.isArray(val) ? (val.join(", ") || "Ninguna") : (val || "");
      });
    });
    properties["Producto"] = PRODUCT_TITLE;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1, properties }] }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("No se pudo añadir al carrito");
        window.location.href = "/checkout";
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = originalText;
        alert("Ha ocurrido un error al procesar tu pedido. Inténtalo de nuevo.");
      });
  });

  updateReveals();
  showStep(0);
})();